import React, { Component } from 'react';
import {interpolateRgb} from 'd3-interpolate';

const PriceNeighborhoodList = ({neighborhoods, price_focus, formatters}) => {
  const interpolate = (value) => {
    if (value < 0.5) {
      return interpolateRgb('#5e3c99','#f7f7f7')(value * 2);
    } else if (value > 1) {
      return '#e66101';
    } else {
      return interpolateRgb('#f7f7f7','#e66101')((value - 0.5) * 2);
    }
  }
  let top_neighborhoods = [];
  let bottom_neighborhoods = [];
  for (let neighborhood of neighborhoods) {
    if (neighborhood.properties.price/2000000 < price_focus/2000000) {
      bottom_neighborhoods.push(neighborhood);
    } else {
      top_neighborhoods.push(neighborhood);
    }
  }
  top_neighborhoods.reverse();

  const neighborhood_item = (neighborhood) => {
    return <div className="clearfix SideListItem tnum h6 col-12 px1" 
      key={neighborhood.properties.neighborhood}
      style={{background: interpolate(neighborhood.properties.price/2000000)}}
    >
      <div className='relative'>
        <div className="">
          {neighborhood.properties.neighborhood}, <span className="capitalize">{neighborhood.properties.borough}</span>
        </div>
        <div className="absolute right-0 top-0">
          {formatters.dollarShort(neighborhood.properties.price)}
        </div>
      </div>
    </div>
  }


  return (
    <div className="flex">
      <div className="col-6">
        <div className="h5 px1">Below ({bottom_neighborhoods.length})</div>
        {bottom_neighborhoods.map((neighborhood => 
          neighborhood_item(neighborhood)
        ))}
      </div>
      <div className="col-6">
        <div className="h5 px1">Above ({top_neighborhoods.length})</div>
        {top_neighborhoods.map((neighborhood => 
          neighborhood_item(neighborhood)
        ))}
      </div>
    </div>
  )
}

export default PriceNeighborhoodList;


/** WEBPACK FOOTER **
 ** ./src/components/PriceNeighborhoodList.js
 **/